import { AbstractApi } from '@/api/AbstractApi'
import request from '@/api/request'

class OrderApi extends AbstractApi {
  async showOrder(uuid: string) {
    const route = this.generateAdminRoute({ uuid })

    return request.get(route)
  }

  async orderIsShipped(uuid: string) {
    const route = this.generateAdminRoute({ uuid, suffix: 'shipped' })

    return request.put(route)
  }

  async orderIsPayed(uuid: string) {
    const route = this.generateAdminRoute({ uuid, suffix: 'payed' })

    return request.put(route)
  }

  async getOrderEmails(uuid: string) {
    const route = this.generateAdminRoute({ uuid, suffix: 'emails' })

    return request.get(route)
  }
}

export default new OrderApi('order')
